import { type RouteRecordRaw } from 'vue-router'

export const hoursRouter: RouteRecordRaw[] = [
  {
    component: async () => import('../views/HoursHomeVersionSwitch.vue'),
    meta: {
      title: 'restaurant.hours',
    },
    name: 'brand.hours',
    path: 'hours',
  },
]
